// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page[data-v-0f77d27e]{padding-bottom:1rem;padding-top:1rem;margin-top:-1rem}.page[data-v-0f77d27e]  header .col{margin-bottom:1em}.context-label[data-v-0f77d27e]{font-size:.875rem}@media(min-width: 1920px){.context-label[data-v-0f77d27e]{font-size:.875vw}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
